import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useNotifications } from '../hooks/useNotifications';
import NotificationDropdown from './NotificationDropdown';

const NotificationBell = ({ isMobile = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    const { user } = useAuth();
    const { unreadCount } = useNotifications();
    
    // Check if user is employer
    const isEmployer = location.pathname.startsWith('/employer') || 
                       user?.user_metadata?.role === 'Employer';
    
    return (
        <div className="relative">
            <button 
                className="rounded-full hover:bg-gray-100 transition p-2 relative"
                onClick={() => setIsOpen(!isOpen)}
                aria-label="Notifications"
            >
                <img 
                    src="/bell-1.svg" 
                    alt="Notifications" 
                    className={isMobile ? "w-6 h-6" : "w-7 h-7"} 
                />
                {unreadCount > 0 && (
                    <span className="absolute top-1 right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></span>
                )}
            </button>
            <NotificationDropdown 
                isOpen={isOpen} 
                    onClose={() => setIsOpen(false)}
                isEmployer={isEmployer}
            />
        </div>
    );
};

export default NotificationBell;

